import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ServiceItem} from "../../../commons/models/service-item.model";


export class ServicesTotalsCtrl implements IController {
  assignData: any;
  services: any[];

  public servicesItems: ServiceItem[];

  constructor() {
  }

  $onInit() {
    if (this.assignData || this.services)
      this._setServicesTotals(this.services)
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.assignData && !changes.assignData.isFirstChange() ||
      changes.services && !changes.services.isFirstChange()) {
      this.$onInit()
    }
  }

  private _setServicesTotals(services) {
    if (!this.assignData) {
      this.assignData = {};
    }
    this.assignData.deliveriesCount = 0;
    this.assignData.fieldServicesCount = 0;

    _.forEach(services, (s) => {
      if (s.serviceType === 'Delivery') {
        this.assignData.deliveriesCount++;
      }
      if (s.serviceType === 'Operation') {
        this.assignData.fieldServicesCount++;
      }
    })

    this.servicesItems = _.flatMap(this.services, 'packageList[0].items').filter(Boolean);
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('servicesTotals', {
    bindings: {
      assignData: '<',
      services: '<'

    },
    template: require('./services-totals.html').default,
    controller: ServicesTotalsCtrl
  });
